/**
 * The socket's wire vocabulary, shared by both ends.
 *
 * ┌─ ⛔ WHY THIS FILE EXISTS: ONE STRING LITERAL WAS THE WHOLE CONTRACT ────────┐
 * │ Found by the code audit's D4-1. `'ready'` was written in FOUR places with   │
 * │ nothing connecting them:                                                    │
 * │                                                                            │
 * │   src/routes/inbox-socket.ts        the server SENDS it                     │
 * │   tests/inbox-socket.test.ts        asserts the server sends it             │
 * │   web/src/data/inbox-socket.ts      the client COMPARES against it          │
 * │   tests/inbox-socket-client.test.ts feeds the client ITS OWN copy           │
 * │                                                                            │
 * │ ⛔ BOTH SIDES WERE ASSERTED, INDEPENDENTLY, EACH AGAINST ITS OWN STRING.    │
 * │ Rename it on the server and update the server test, and every suite stays   │
 * │ GREEN while the client never matches again.                                 │
 * │                                                                            │
 * │ ⚠️ AND THE CONSEQUENCE IS SPECIFIC, because `isReady` gates two things:     │
 * │   - `setState({ kind: 'live' })`  - the connection never reads as live      │
 * │   - the refetch on `ready`, which is "a reconnect's whole purpose... to     │
 * │     recover what was missed WHILE DISCONNECTED, and no frame announces      │
 * │     those" - silently never recovered.                                      │
 * └────────────────────────────────────────────────────────────────────────────┘
 *
 * ┌─ ⛔ A LEAF MODULE, AND THAT IS NOT AN AESTHETIC CHOICE ─────────────────────┐
 * │ The obvious home was `src/routes/inbox-socket.ts`, which already exports    │
 * │ `HEARTBEAT_INTERVAL_MS`. But the client would then import a VALUE from a    │
 * │ file that imports fastify, and value imports are not erased - it would pull │
 * │ the server's dependency graph into the browser bundle. Type imports are     │
 * │ free and the client already uses several; values are not.                   │
 * │                                                                            │
 * │ ✅ SO THIS FILE IMPORTS NOTHING. That is the property that lets both ends   │
 * │ share it, and it is the reason to keep it that way.                         │
 * └────────────────────────────────────────────────────────────────────────────┘
 */

/**
 * Sent once when the socket is established and after every reconnect.
 *
 * ⚠️ THE CLIENT READS THE CONTENT OF EXACTLY ONE FRAME FIELD, and this is it.
 * Every other frame triggers a refetch without being parsed for meaning, because
 * the payload is ids only and the database is the answer.
 */
export const SOCKET_EVENT_READY = 'ready'

/**
 * Sent every `HEARTBEAT_INTERVAL_MS` to keep the connection observable.
 *
 * ⚠️ THE CLIENT NEVER COMPARES AGAINST THIS, deliberately: its watchdog re-arms
 * on EVERY frame, "heartbeat or not", including unparseable ones. The constant
 * exists so the server's two event names are declared in one place rather than
 * one being shared and the other left loose - a half-shared vocabulary is how
 * the next one drifts.
 */
export const SOCKET_EVENT_HEARTBEAT = 'heartbeat'
